import React from "react";

const CircularSegmentProgress = ({
    progress = 0,
    size = 100,
    strokeWidth = 5,
}) => {
    const radius = 50 - strokeWidth / 2;  // radius considering stroke width (viewBox 100x100)
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference * (1 - progress / 100);
    return (
        <div className="relative flex items-center justify-center">
            <svg
                width={size}
                height={size}
                viewBox="0 0 100 100"
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`Progress: ${progress.toFixed(2)}%`}
            >
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    stroke="#E5E7EB"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    stroke="url(#gradient)"
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    transform="rotate(-90 50 50)"
                    className="transition-all duration-500"
                />
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#A73884" />
                        <stop offset="100%" stopColor="#803A85" />
                    </linearGradient>
                </defs>
            </svg>
            <div className="absolute inset-0 flex items-center justify-center font-medium text-[#6D6D6E] select-none text-[20px]">
                {progress.toFixed(2)}%
            </div>
        </div>
    );
};

export default CircularSegmentProgress;
